module.exports = __webpack_public_path__ + "img/welcome.8fbf8b0e.jpg";